import { faAddressBook, faBriefcase, faBuildingColumns, faClock, faEnvelope, faFlag, faLandmarkDome, faLocationCrosshairs, faLocationDot, faMapLocationDot, faPenFancy, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import { FaFacebook, FaInstagramSquare, FaLinkedin, FaTwitterSquare } from 'react-icons/fa';
import { getValueOrPlaceHolder } from '../../../../../Utils/helpers/commonhelper';

export const CompanyInformationPanel = ({ companyData, parsedUserEmail, parsedUserPhone }) => {
    const [showAllEmails, setShowAllEmails] = useState(false);
    const [showAllPhoneNumbers, setShowAllPhoneNumbers] = useState(false);
    const company_timezone = JSON.parse(companyData[0]?.timezone);
    return (
        <Row className="w-100 ms-0 ps-0 pe-2 mt-2 mb-2 contactDetailOffcanvas">
            <Col
                md={12}
                className="tab-container bg-white ps-0 pe-0"
                style={styles.tabContainer}
            >
                <Tab.Container defaultActiveKey="products">
                    <Nav
                        variant="pills"
                        className="nav-style-1 mb-0 d-flex flex-nowrap "
                    >
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="products"
                                style={styles.navLinksStyle}
                            >
                                Communication
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="cart"
                                style={styles.navLinksStyle}
                            >
                                Location
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="orders"
                                style={styles.navLinksStyle}
                            >
                                Social
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                        >
                            <Nav.Link
                                eventKey="offers"
                                style={styles.navLinksStyle}
                            >
                                Professional
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{ minWidth: "22%" }}
                        >
                            <Nav.Link
                                eventKey="Campaign"
                                style={styles.navLinksStyle}
                            >
                                Internal
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item
                            className="me-0"
                            style={{
                                width: "-webkit-fill-available",
                                borderBottom: "1px solid #E0E4F8",
                            }}
                        ></Nav.Item>
                    </Nav>

                    <Tab.Content>
                        <Tab.Pane
                            eventKey="products"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-0 mt-3 ">
                                <Col
                                    md={4}
                                    className="mb-4 d-flex align-items-start "
                                >
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "1px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div className="w-100">
                                        <p className="mb-0" style={styles.labels}>
                                            Emails
                                        </p>

                                        <div
                                            style={{
                                                fontSize: "14px",
                                                color: "#333",
                                            }}
                                        >

                                            {parsedUserEmail?.[0]?.email ? (
                                                <>
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            maxWidth: "250px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            verticalAlign: "middle",
                                                        }}
                                                        title={parsedUserEmail[0].email} // tooltip on hover
                                                    >
                                                        <span
                                                            className=" d-inline-block"
                                                            style={{
                                                                // display:"inline-block !important",
                                                                width: "70px",
                                                                minWidth: "60px",
                                                            }}
                                                        >
                                                            {parsedUserEmail[0].email_type}
                                                        </span>
                                                        : {parsedUserEmail[0].email}
                                                    </span>
                                                    <br />
                                                    {parsedUserEmail.length > 1 &&
                                                        !showAllEmails && (
                                                            <span
                                                                style={{
                                                                    color: "#0d6efd",
                                                                    cursor: "pointer",
                                                                    // marginLeft: "8px",
                                                                    fontSize: "13px",
                                                                }}
                                                                onClick={() =>
                                                                    setShowAllEmails(true)
                                                                }
                                                            >
                                                                +{parsedUserEmail.length - 1} more
                                                            </span>
                                                        )}
                                                </>
                                            ) : (
                                                getValueOrPlaceHolder(parsedUserEmail?.[0]?.email)
                                            )}
                                        </div>

                                        {/* Expanded emails */}
                                        {showAllEmails && (
                                            <div
                                                style={{
                                                    marginTop: "6px",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    transition: "all 0.3s ease",
                                                }}
                                            >
                                                {parsedUserEmail
                                                    .slice(1)
                                                    .map((allEmails, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                marginBottom: "4px",
                                                                display: "inline-block",
                                                                maxWidth: "250px", // adjust as needed
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                verticalAlign: "middle",
                                                                // border:"1px solid black"
                                                            }}
                                                            title={allEmails.email} // tooltip
                                                        >
                                                            <span
                                                                className=" d-inline-block"
                                                                style={{
                                                                    // display:"inline-block !important",
                                                                    width: "70px",
                                                                    minWidth: "60px",
                                                                }}
                                                            >
                                                                {allEmails.email_type}
                                                            </span>
                                                            : {allEmails.email}
                                                        </div>
                                                    ))}
                                                <br />
                                                <span
                                                    style={{
                                                        color: "#0d6efd",
                                                        cursor: "pointer",
                                                        fontSize: "13px",
                                                    }}
                                                    onClick={() => setShowAllEmails(false)}
                                                >
                                                    Show less
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </Col>

                                <Col
                                    md={4}
                                    className="mb-4 d-flex align-items-start  "
                                    style={{ marginLeft: "80px" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "1px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div className="w-100">
                                        <p className="mb-0" style={styles.labels}>
                                            Contacts
                                        </p>

                                        <div
                                            style={{
                                                fontSize: "14px",
                                                color: "#333",
                                            }}
                                        >
                                            {parsedUserPhone?.[0]?.phone ? (
                                                <>
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            maxWidth: "250px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            verticalAlign: "middle",
                                                            letterSpacing: "0.25px"
                                                        }}
                                                        title={`${parsedUserPhone[0].phone_type} + ${parsedUserPhone[0].country_code} ${parsedUserPhone[0].phone}`} // full tooltip
                                                    >
                                                        <span
                                                            className=" d-inline-block"
                                                            style={{
                                                                // display:"inline-block !important",
                                                                width: "60px",
                                                                minWidth: "50px",
                                                            }}
                                                        >
                                                            {parsedUserPhone[0].phone_type}
                                                        </span>

                                                        : {parsedUserPhone[0].country_code}{" "}
                                                        {parsedUserPhone[0].phone}
                                                    </span>

                                                    <br />
                                                    {parsedUserPhone.length > 1 &&
                                                        !showAllPhoneNumbers && (
                                                            <span
                                                                style={{
                                                                    color: "#0d6efd",
                                                                    cursor: "pointer",
                                                                    // marginLeft: "8px",
                                                                    fontSize: "13px",
                                                                }}
                                                                onClick={() =>
                                                                    setShowAllPhoneNumbers(true)
                                                                }
                                                            >
                                                                +{parsedUserPhone.length - 1} more
                                                            </span>
                                                        )}
                                                </>
                                            ) : (
                                                getValueOrPlaceHolder(parsedUserPhone?.[0]?.phone)
                                            )}
                                        </div>

                                        {/* Expanded contacts */}
                                        {showAllPhoneNumbers && (
                                            <div
                                                style={{
                                                    marginTop: "6px",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    transition: "all 0.3s ease",
                                                }}
                                            >
                                                {parsedUserPhone
                                                    .slice(1)
                                                    .map((allPhones, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                marginBottom: "4px",
                                                                display: "inline-block",
                                                                maxWidth: "250px",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                verticalAlign: "middle",
                                                            }}
                                                            title={`${allPhones.phone_type} + ${allPhones.country_code} ${allPhones.phone}`} // tooltip
                                                        >
                                                            <span
                                                                className=" d-inline-block"
                                                                style={{
                                                                    // display:"inline-block !important",
                                                                    width: "60px",
                                                                    minWidth: "50px",
                                                                }}
                                                            >
                                                                {allPhones?.phone_type}
                                                            </span>

                                                            : +{allPhones.country_code}{" "}
                                                            {allPhones.phone}
                                                        </div>
                                                    ))}
                                                <br />
                                                <span
                                                    style={{
                                                        color: "#0d6efd",
                                                        cursor: "pointer",
                                                        fontSize: "13px",
                                                    }}
                                                    onClick={() =>
                                                        setShowAllPhoneNumbers(false)
                                                    }
                                                >
                                                    Show less
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                                <Col
                                    md={6}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "1px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            TimeZone
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {companyData[0].timezone
                                                ? company_timezone?.label
                                                : "-"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="cart"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faFlag}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Country
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].country_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faBuildingColumns}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            State
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].state_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationCrosshairs}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            City
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].city_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Address
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].address)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faMapLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Zip Code
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].zipcode)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="orders"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaFacebook
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Facebook
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].facebook)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaLinkedin
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Linkedin
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].linkedin)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-4 mt-0">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaInstagramSquare
                                        className=" fs-16"
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Instagram
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].instagram)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FaTwitterSquare
                                        className=" fs-16"
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Twitter
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].twitter)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="offers"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLandmarkDome}
                                        style={{
                                            fontSize: "18px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Company
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].company_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faBriefcase}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Business Type
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].business_type)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-3 mt-0">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faAddressBook}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Industry
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].industry)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPenFancy}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Employee Size
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].employee_size)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane
                            eventKey="Campaign"
                            style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                            }}
                        >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Created By
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].added_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                        className=" fs-16"
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Created At
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {companyData[0].created_at
                                                ? new Date(
                                                    companyData[0].created_at
                                                ).toLocaleDateString()
                                                : getValueOrPlaceHolder(companyData[0].created_at)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Modified by
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].updater_name)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Modified At
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {companyData[0].updated_at
                                                ? new Date(
                                                    companyData[0].updated_at
                                                ).toLocaleDateString()
                                                : getValueOrPlaceHolder(companyData[0]?.updated_at)}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    md={4}
                                    className="mb-3 d-flex align-items-start"
                                >
                                    <FontAwesomeIcon
                                        icon={faLocationDot}
                                        className=" fs-16"
                                        style={{
                                            fontSize: "16px",
                                            marginRight: "13px",
                                            color: "#2656a8",
                                            marginTop: "6px",
                                        }}
                                    />
                                    <div>
                                        <p className="mb-0" style={styles.labels}>
                                            Lead Owner
                                        </p>
                                        <p className="mb-0" style={styles.values}>
                                            {getValueOrPlaceHolder(companyData[0].owner_name)}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Col>
        </Row>
    )
}
const styles = {
    bottomP: {
        fontSize: 11,
    },
    bottomH4: {
        marginBottom: 2,
    },
    buttons: {
        color: "#fff",
        fontSize: "13px",
        height: "27px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "-16px",
    },
    filterbuttons: {
        fontSize: "13px",
        height: "34px",
        width: "34px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    ulStyles: {
        display: "flex",
        alignItems: "center",
        gap: "3px",
        justifyContent: "space-between",
        width: "100%",
    },
    listButtonsStyles: {
        fontSize: "13px",
        // borderBottom: '1px solid #e3e3e3',
        height: "30px",
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        gap: 3,
    },
    navButtonsStyles: {
        fontSize: "15px",
        height: "34px",
        minWidth: "34px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    iconStyles: {
        fontSize: 13,
        color: "#fff",
    },
    emptyDivs: {
        borderRight: "1px solid #E0E4F8",
        height: "35px",
        margin: "0px 2px",
    },
    DropdownItemsStyle: {
        fontSize: ".93re",
        letterSpacing: ".0386rem",
        fontWeight: 400,
        color: "#2e384d",
    },
    navLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    inActiveNavLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,



        lineHeight: 1.5,
        pointerEvents: "none",
    },
    tabContainer: {
        border: "1px solid #E0E4F8",
        borderRadius: "4px",
    },
    stickyHeader: {
        paddingBottom: "11px",
        position: "sticky",
        background: "#fff",
        top: "0px",
    },
    labels: {
        fontSize: "12px",
        color: "#B0BAC9",
        fontWeight: 400,
    },
    iconsStyles: {
        color: "#2656a8",
        border: "1px solid #e6e6e6",
        background: "#e9f1ff",
        padding: "9px",
        borderRadius: "50%",
        marginRight: "10px",
        width: "15px",
        height: "15px",
        fontSize: "13px",
    },
    values: {
        color: "#2e384d",
        fontWeight: 400,
        fontSize: ".8333rem",
        letterSpacing: '0.25px',
    },
    accordion__item: {
        borderRadius: "0px",
        borderBottom: " 1px solid #d7d7d7",
        animation: "cardEntry 1s ease-out forwards",
    },
    accordion__heading: {
        width: "100%",
    },
    accordion__panel: {
        padding: "14px 0px ",
        maxHeight: "35rem",
        overflow: "auto",
        minHeight: "35rem",
        animation: "cardEntry 1s ease-out forwards",
    },
    accordion__button: {
        display: "flex",
        alignItems: "center",
        padding: "13px 20px",
        justifyContent: "space-between",
        background: "#f4f4f4",
    },
    accordion__title: {
        marginBottom: 0,
        fontWeight: 300,
        letterSpacing: "0.0119rem",
        fontSize: "1rem",
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        gap: "5px",
    },
    contactDetails: {
        display: "flex",
        alignItems: "center",
        gap: "13px",
        padding: "14px 16px ",
        borderBottom: "0.01rem solid #ebebeb",
    },
    roundedIcons: {
        width: "45px",
        height: "45px",
        backgroundColor: "#d5d6e8",
        color: "#2e384d",
    },
    departmentName: {
        color: "#3f97fd",
        fontSize: "13px",
        fontWeight: 400,
        marginLeft: "9px",
        marginBottom: 0,
    },
    departmentEmails: {
        color: "grey",
        fontWeight: 300,
    },
    listButtonsStyless: {
        fontSize: "13px",
        // borderBottom: '1px solid #e3e3e3',
        height: "30px",
        width: "56px",
        gap: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        color: "#fff",
    },
};